import React, { useEffect } from "react";
import { useCurrent, useFetch } from "../../../hooks";
import WarehousesListItem from "./WarehousesListItem";
import { MwSpinner, NoDataFound } from "../../../components/ui";
import { useTranslation } from "react-i18next";

const WarehousesList = ({ reloadList, onEdit, onView, refreshHandler }) => {
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();
  const {
    data: warehosesResult,
    loading: loadingWarehouse,
    setData: setWarehousesData,
  } = useFetch(
    `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`,
  );
  const [t, i18n] = useTranslation("global");
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    if (warehosesResult) {
      console.log("warehouses", warehosesResult);
    }
  }, [warehosesResult]);

  useEffect(() => {
    if (reloadList) {
      refreshHandler();
    }
  }, [reloadList]);

  if (loadingWarehouse) {
    return <MwSpinner />;
  }

  return (
    <>
      {!warehosesResult ||
      !warehosesResult?.data ||
      warehosesResult?.data.length == 0 ? (
        <NoDataFound msg={t("reports.No_Results")} />
      ) : (
        //  <div className="min-w-[600px] mt-3 relative">
        <div className="sticky top-0 z-10 p-3  h-screen max-h-[calc(100vh-170px)] bg-white rounded">
          <div className="grid grid-cols-12 gap-3 px-4 mt-2 bg-[#ebf9d9] font-normal text-[#251658] text-sm  justify-between items-center border-t py-4  ">
            <div className="text-center col-span-1">#</div>
            <div className="text-center col-span-2">
              {t("requisition.warehouse_code")}
            </div>
            <div className=" col-span-4">{t("stocktaking.warehouse_name")}</div>
            <div className="  col-span-2">{t("stocktaking.title")}</div>
            <div className="text-center col-span-2">
              {t("requisition.creation_date")}
            </div>
            <div className="col-span-1"></div>
          </div>
          <div className="custom-scrollbar h-[calc(100%-4rem)] overflow-y-auto">
            {warehosesResult?.data.map((item, index) => (
              <WarehousesListItem
                key={item.id}
                setItems={setWarehousesData}
                isRTL={isRTL}
                index={index}
                refreshHandler={refreshHandler}
                item={item}
                onView={onView}
                onEdit={onEdit}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default WarehousesList;
